import { NACID_COVERAGE, NACID_FLOWS, NacidServicePath } from "utils/constants";

// NACID flow administration. Everything here is a sub-resource operation or an ad-hoc read that does not fit
// react-admin's CRUD shape, so it goes through dataProvider.customRequest with a URL built here.
//
// The flow list and the flow detail are NOT in this file — they are plain react-admin getList/getOne on the
// resource, and the detail already returns its steps and their HTTP attempts nested. Only the request/response
// *bodies* need a separate call, because they sit behind their own permission.
export const nacidRequests = {
  getFlowStepRequests: (flowId, stepId) => `${NacidServicePath}${NACID_FLOWS}/${flowId}/steps/${stepId}/requests`,

  retryFlow: flowId => `${NacidServicePath}${NACID_FLOWS}/${flowId}/retry`,

  cancelFlow: flowId => `${NacidServicePath}${NACID_FLOWS}/${flowId}/cancel`,

  resolveStepManually: (flowId, stepId) => `${NacidServicePath}${NACID_FLOWS}/${flowId}/steps/${stepId}/resolve-manual`,

  redoStep: (flowId, stepId) => `${NacidServicePath}${NACID_FLOWS}/${flowId}/steps/${stepId}/redo`,

  reconcileCoverage: () => `${NacidServicePath}${NACID_COVERAGE}/reconcile`,
};
